import {AgentGroup, AgentGroupData} from "../model/AgentGroup";
import {HashMap} from "../model/HashMap";
import {Utilities} from "../utilities";

function parseAgentGroupsData(agentGroupsData: AgentGroupData[]): HashMap<AgentGroup> {
    const agentGroupHash: HashMap<AgentGroup> = {};
    for (const agentGroup of agentGroupsData) {
        const existingGroup: AgentGroup = agentGroupHash[agentGroup.name];
        if (existingGroup) {
            console.error(`Duplicate agent group name ${agentGroup.name} found. `
                + `State already has one from environment ${existingGroup.environment}. `
                + `Will ignore new one from environment ${agentGroup.environmentName}.`);
        } else {
            agentGroupHash[agentGroup.name] = {
                displayName: agentGroup.displayName,
                name: agentGroup.name,
                environment: agentGroup.environmentName,
                environmentDisplayName: agentGroup.environmentDisplayName,
                agents: agentGroup.agents,
                allowRunningTestProcesses: agentGroup.allowRunningTestProcesses,
                isCrossPlatform: agentGroup.isCrossPlatform,
                allowLogEverything: agentGroup.allowLogEverything
            };
        }
    }
    return agentGroupHash;
}

/** Only done within the initial fetch */
export function fetchAgentGroups(): Promise<HashMap<AgentGroup>> {
    return Utilities.getFetch<AgentGroupData[]>("api/environment/agentGroups")
        .then((result) => parseAgentGroupsData(result));
}
